import { GatingLevel } from "./gating-level.js";

/**
 * Gating State Values: 
 * Similar to the GatingLevel values, but adds also account for application state based on cookies, known visitor status, etc.
 */
export namespace GatingState {
  /** Gating States for marketo form components. This includes GatingLevel.MarketoForm values plus any dynamically determined states */
  export const MarketoForm = Object.freeze([...GatingLevel.MarketoForm, "BlindSubmit"] as const);
  export type MarketoForm = typeof MarketoForm[number];

  /** Gating State values for Form Experiences. This includes GatingLevel.FormExperience values plus any dynamically determined states */
  export const FormExperience = Object.freeze([... GatingLevel.FormExperience, "BlindSubmit"] as const);
  export type FormExperience = typeof FormExperience[number];
  
  /** Gating State values returned after reading the user cookie.  "NeedsForm" indicates the cookie was not set. */
  export const UserCookie = Object.freeze([...GatingLevel.MarketoForm, "NeedsForm"] as const);
  export type UserCookie = typeof UserCookie[number];

  export namespace PossibleValues {
    /** Get a GatingState type for Marketo forms, only including the allowed gating states.  */
    export type forMarketoForm<TAllowedGatingState extends GatingState.MarketoForm> = TAllowedGatingState;

    /** Get a GatingState type for form experiences, only including the allowed gating states.  */
    export type forFormExperience<TAllowedGatingState extends GatingState.FormExperience> = TAllowedGatingState;
  }
}

export type GatingStateFor<TFormOrExperience extends "MarketoForm" | "FormExperience"> =
  TFormOrExperience extends "MarketoForm"
    ? GatingState.MarketoForm
    :
  TFormOrExperience extends "FormExperience"
    ? GatingState.FormExperience
    : never;